import { useTrackRoute } from '@/lib/hooks/tracking';

const RouteTracker = () => {
  useTrackRoute();

  return null;
};

export default RouteTracker;
